<template>
  <div>
    <span class="text-capitalize font-weight-medium">{{ queryParam }}: </span>
    <span class="font-weight-black">{{ selectedItem }}</span>
  </div>
</template>

<script>
export default {
  name: 'ModalFilterList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Array],
      required: true,
    },
    queryParam: {
      type: String,
      required: true,
    },
  },
  computed: {
    selectedItem() {
      return Array.isArray(this.value)
        ? this.formatList(this.value.map(item => this.findKey(item)))
        : this.findKey(this.value)
    },
  },
  methods: {
    findKey(valueToFind) {
      const found = this.items.find(({ value }) => value === valueToFind)
      return found?.key || ''
    },
    formatList(arr) {
      const formatter = new Intl.ListFormat('en', { style: 'long', type: 'disjunction' })
      return formatter.format(arr)
    },
  },
}
</script>
